import ContactComponent from "./../SharedComponent/ContactComponent";
import logo2 from "./../assets/images/parts-and-supplies/parts.webp";
import "./../css/PartsAndSuppliesPage.css";
import PageBreadCrumbs from "./../SharedComponent/page-breadcrumbs";
import { useEffect } from "react";

const PartsAndSuppliesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <PageBreadCrumbs
        title="Parts And Supplies"
        subtitle="Reliable Filters & Supplies"
        breadcrumbs={{
          currentPage: "Parts And Supplies",
          items: [{ name: "Home", href: "/" }],
        }}
      />
      <div className="parts-supplies-container">
        <div className="parts-supplies-grid">
          {/* Left Column */}
          <div className="left-column">
            <ContactComponent />
          </div>

          {/* Right Column */}
          <div className="right-column">
            {/* Intro Paragraph */}
            <p className="intro-paragraph">
              We maintain a ready inventory of commonly used parts and
              industrial air filters. Reach out with your requirements, and let
              us help you receive custom replacement filters and components more
              quickly through our tailored stocking program.
            </p>

            {/* Separator Image */}
            <div className="separator-image">
              <img src={logo2} alt="Parts and Supplies" />
            </div>

            {/* Detailed Section */}
            <div className="detailed-section">
              <h2 className="section-title">
                Your Source for Industrial Replacement Air Filters
              </h2>

              <p>
                We offer a range of air filters and dust collection solutions,
                including:
              </p>

              <ul className="filter-list">
                <li>Baghouse dust collector filters</li>
                <li>Cartridge filters</li>
                <li>PowerCore® Filter Packs</li>
                <li>Panel filters</li>
                <li>Filters for Mist collection</li>
                <li>HEPA Filters</li>
                <li>Other air filters for dust, fume, and mist collection</li>
              </ul>

              <p>
                At PS Environmental, we're committed to improving air quality
                and creating cleaner work environments. With decades of
                experience, our team specializes in designing, installing, and
                maintaining industrial air filtration systems for manufacturing
                facilities nationwide.
              </p>

              <p>
                Regardless of the dust collection, fume extraction, mist
                collection, or air filtration system you use, we can recommend
                the ideal replacement filters for your setup.
              </p>

              <p>
                Our team at IAF is dedicated to supporting you with a reliable
                supply of high-quality replacement filters tailored for your
                industrial equipment and applications.
              </p>

              <h3 className="section-subtitle">
                Facility Manager? Simplify Your Work with Our Restocking and
                Maintenance Program
              </h3>

              <p>
                We offer restocking, installation, and maintenance services to
                help ensure your workspace maintains clean air. Let our team
                handle filter replacements and ongoing upkeep so you don't have
                to. With our programs, you'll never have to worry about staying
                on top of air filtration changes. Get in touch with us to learn
                more.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartsAndSuppliesPage;
